<template>
  <div v-if="profileLoaded" class="content-block-preview">
    <modal-title :title="title" @close="$emit('close')" />
    <tabbed-view
      :default-tab="isHtmlContentBlock ? 'prw-preview' : 'prw-legacy'"
    >
      <template v-slot:tabs="{ context, tabClicked }">
        <tab
          v-if="isHtmlContentBlock"
          id="prw-preview"
          :context="context"
          label="Preview"
          @click="tabClicked"
        ></tab>
        <tab
          v-if="isLegacyContentBlock"
          id="prw-legacy"
          :context="context"
          :label="legacyTabTitle"
          @click="tabClicked"
        ></tab>
        <tab
          v-if="
            showEditTab &&
            capabilities.editContentBlockDetails
          "
          id="prw-details"
          :context="context"
          label="Details"
          @click="tabClicked"
        ></tab>
      </template>
      <template v-slot:content="{ context }">
        <tab-pane id="prw-preview" :context="context">
          <div
            class="preview-container"
            v-html="contentBlock.htmlContent"
          ></div>
          <form-buttons>
            <button
              v-if="contentBlock.availableForDocumentAuthors"
              type="button"
              class="btn btn-primary bg-info"
              @click="$emit('insert', contentBlock)"
            >
              Insert
            </button>
            <button
              v-if="
                isDocumentAdmin &&
                currentTemplates &&
                currentTemplates.length > 0 &&
                contentBlock.availableForTemplateAuthors
              "
              type="button"
              class="btn btn-primary"
              @click="$emit('add-tag', contentBlock)"
            >
              Insert Tag
            </button>
          </form-buttons>
        </tab-pane>
        <tab-pane id="prw-details" :context="context">
          <edit-form
            :systemName="contentBlock.systemName"
            @close="(args) => $emit('close', args)"
          ></edit-form>
        </tab-pane>
        <tab-pane id="prw-legacy" :context="context">
          <legacy-preview
            v-if="showLegacyPreview"
            :content-block="contentBlock"
          />
          <button
            type="button"
            class="btn btn-primary bg-info"
            @click="$emit('add-tag', contentBlock)"
          >
            Insert
          </button>
        </tab-pane>
      </template>
    </tabbed-view>
  </div>
</template>
<script>
import profile from "@/mixins/profile";
import currentTempates from "@/mixins/currentTemplates";
import ModalTitle from "@/components/common/modal/ModalTitle.vue";
import LegacyPreview from "@/components/content-blocks/LegacyContentBlockPreview.vue";
import { TabbedView, Tab, TabPane } from "@/components/common/tabs/index.js";
import EditForm from "./EditForm.vue";
import {
  ADMIN_DOCUMENT_ASSEMBLY,
  CONTENT_BLOCKS_READ,
  CONTENT_BLOCKS_CREATE,
} from "@/constants/permissions";
import {
  CONTENT_BLOCK_DOCUMENT,
  CONTENT_BLOCK_HTML,
} from "@/constants/templateTypes";

export default {
  components: { ModalTitle, TabbedView, Tab, TabPane, EditForm, LegacyPreview },
  mixins: [profile, currentTempates],
  props: {
    contentBlock: {
      required: true,
    },
    showEditTab: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    title: function () {
      return this.isHtmlContentBlock ? "HTML Block" : "Word Block";
    },
    isDocumentAdmin: function () {
      return this.hasPermission(ADMIN_DOCUMENT_ASSEMBLY);
    },
    canReadContentBlocks: function () {
      return this.hasPermission(CONTENT_BLOCKS_READ);
    },
    canUpdateContentBlocks: function () {
      return this.hasPermission(CONTENT_BLOCKS_CREATE);
    },
    isHtmlContentBlock: function () {
      return this.contentBlock.templateType === CONTENT_BLOCK_HTML;
    },
    isLegacyContentBlock: function () {
      return this.contentBlock.templateType === CONTENT_BLOCK_DOCUMENT;
    },
    legacyTabTitle: function () {
      return this.showLegacyPreview
        ? "Preview"
        : "Insert";
    },
    showLegacyPreview: function () {
      return (
        !!this.capabilities.legacyContentBlocksPreview &&
        !!this.contentBlock.templateRepository
      );
    },
  },
  emits: ["insert", "add-tag", "close"],
};
</script>
<style lang="scss" scoped>
.content-block-preview {
  text-align: initial !important;
}
</style>
